const useIsStudent = (userContext:any) => {
  const { idProfessor, observador, colaborador, usuarioTrial, usuarioDegustacao } = userContext
  return (idProfessor == 0 && !observador && !colaborador && !usuarioTrial && !usuarioDegustacao)
}

export default useIsStudent